import { Theme } from '@mui/material'
import { makeStyles, createStyles } from '@mui/styles'
import React, { memo } from 'react'
import { IImgColor, IBankLogo } from './typings'

const useStyles = makeStyles<
  Theme,
  {
    logoSrc: string
    customSizing?: { height: number | string; width: number | string }
  }
>((theme: Theme) =>
  createStyles({
    logoCls: {
      backgroundImage: ({ logoSrc }) => `url(${logoSrc})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      minHeight: ({ customSizing }) =>
        customSizing ? customSizing.height : 50,
      minWidth: ({ customSizing }) => (customSizing ? customSizing.width : 120),
      [theme.breakpoints.down('md')]: {
        maxHeight: 30,
        maxWidth: 30,
      },
    },
  }),
)

const BankLogo = ({
  logoSrc,
  logoColor = IImgColor.COLOR,
  customSizing,
}: IBankLogo) => {
  const { logoCls } = useStyles({
    logoSrc: logoSrc[logoColor],
    customSizing,
  })

  return <div className={logoCls} />
}

export default memo(BankLogo)
